import { Component, Input } from '@angular/core';
import { SHARED_MODULES } from '../../../shared.';
import { SanitizerPipe } from '../../pipes/sanitizer.pipe';

export interface UserData {
	name: string,
	image: string
}

@Component({
    selector: 'app-user-logo-generate[user]',
    templateUrl: './user-logo-generate.component.html',
    styleUrls: ['./user-logo-generate.component.scss'],
	imports: [SHARED_MODULES, SanitizerPipe],
    standalone: true
})
export class UserLogoGenerateComponent {

	avatarName: string = '';
    image: string = '';
    name: string = '';

	@Input('user') set setUser(user: UserData) {
        this.avatarName = '';
        
        user?.name
			.trim()
			.toUpperCase()
			.split(' ')
			.forEach(word => this.avatarName += word[0]);

		this.avatarName = this.avatarName.slice(0, 3);
        this.image = user?.image;
        this.name = user?.name;
    };
	@Input('size') size: number = 30;
	@Input('radius') radius: string = '5px';

	constructor() {}
}
